import * as actionTypes from './actionTypes';
import * as actions from './index';

import { CHAPTER_MARK } from 'Flow2/components/VideoPlayer/ChapterPlayer';

const deleteCommentStart = () => {
    return {
        type: actionTypes.DELETE_COMMENT_START
    };
};

const deleteCommentSuccess = () => {
    return {
        type: actionTypes.DELETE_COMMENT_SUCCESS
    };
};

const deleteCommentFail = (error) => {
    return {
        type: actionTypes.DELETE_COMMENT_FAIL,
        error: error
    };
};

export const deleteComment = (id, clipId, projectId) => {
    return dispatch => {
        dispatch(deleteCommentStart());
        window.flow.delComments(id).then(res => {
            dispatch(deleteCommentSuccess());
            dispatch(getComments(clipId, projectId));
        }).catch(res => {
            dispatch(deleteCommentFail(res.message));
            dispatch(actions.applicationError(res.message));
        });
    };
};

const getCommentsStart = () => {
    return {
        type: actionTypes.GET_COMMENTS_START
    };
};

const getCommentsSuccess = (res, clipId, projectId) => {
    return {
        type: actionTypes.GET_COMMENTS_SUCCESS,
        payload: { comments: res, clipId: clipId, projectId: projectId }
    };
};

const getCommentsFail = (error) => {
    return {
        type: actionTypes.GET_COMMENTS_FAIL,
        error: error
    };
};


//TIME_COMMENTS BEGIN
export const getClipTimeCommentsSuccess = (res, clipId) => {
    return {
        type: actionTypes.GET_CLIP_TIME_COMMENTS_SUCCESS,
        payload: { data: res, clipId: clipId }
    }
}

export const getClipTimeComments = (clipId, type = 'comment') => {
    return dispatch => {
        window.flow.getComments({ 'clipid': clipId, type: type })
            .then(res => {
                if (res && res.comment && res.comment.elements)
                    dispatch(getClipTimeCommentsSuccess(res.comment.elements, clipId));
            })
            .catch(error => console.log(error));
    }
}

export const addClipTimeComment = (clipId, entry) => {
    return dispatch => {
        if (entry && entry.comment) {

            let tcin = entry.tcin ? entry.tcin : '0.0';
            let tcout = entry.tcout ? entry.tcout : '0.0';
            let obj = {
                'mode': 'CREATE',
                'comment': entry.comment,
                'tcin': tcin,
                'tcout': tcout,
                'clipid': clipId
            }

            // NICK START
            if (entry.type) { obj.type = entry.type; }
            if (entry.name) { obj.name = entry.name; }
            // NICK END

            window.flow.editComment(obj)
                .then(res => {
                    dispatch(getClipTimeComments(clipId, entry.type));
                })
                .catch(error => console.log(error));
        }
    }
}

export const deleteClipTimeComment = (clipId, commentId, entry) => {
    return dispatch => {
        window.flow.delComments(commentId)
            .then(res => {
                dispatch(getClipTimeComments(clipId, entry.type));
            })
            .catch(error => console.log(error));
    }
}

export const updateClipTimeComment = (clipId, entry) => {
    return dispatch => {
        if (clipId && entry) {
            window.flow.editComment({ ...entry, 'mode': 'EDIT' })
                .then(res => {
                    dispatch(getClipTimeComments(clipId, entry.type));
                })
                .catch(error => console.log(error));
        }
    }
}

export const setClipTimeCurrent = (clipId, currentTarget) => {
    if (clipId && currentTarget) {
        return {
            type: actionTypes.SET_CLIP_TIME_CURRENT_SUCCESS,
            payload: { clipId, currentTarget }
        }
    }
}

export const changeClipTimeCurrent = (clipId, changedTime) => {
    if (clipId && (changedTime)) {
        return {
            type: actionTypes.CHANGE_CLIP_TIME_CURRENT_SUCCESS,
            payload: { clipId, changedTime }
        }
    }
}

//TIME_COMMENTS END

export const getComments = (clipId, projectId = 0) => {
    return dispatch => {
        dispatch(getCommentsStart());
        window.flow.getComments({ clipid: clipId, project: projectId, type: 'comment' }).then(res => {
            dispatch(getCommentsSuccess(res, clipId, projectId));
        }).catch(res => {
            dispatch(getCommentsFail(res.message));
            dispatch(actions.applicationError(res.message));
        });
    };
};

const addCommentStart = () => {
    return {
        type: actionTypes.ADD_COMMENT_START
    };
};

const addCommentSuccess = () => {
    return {
        type: actionTypes.ADD_COMMENT_SUCCESS
    };
};

const addCommentFail = (error) => {
    return {
        type: actionTypes.ADD_COMMENT_FAIL,
        error: error
    };
};

export const addComment = (comment, clipId, projectId, name) => {
    return dispatch => {
        dispatch(addCommentStart());
        window.flow.editComment({ clipid: clipId, project: projectId, type: 'comment', comment: comment, name: name }).then(res => {
            dispatch(addCommentSuccess());
            dispatch(getComments(clipId, projectId));
        }).catch(res => {
            dispatch(addCommentFail(res.message));
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const addThumb = (clipId, time, chapter = time, width = 1280, height = 720) => {

    const params = {
        createthumbmf: 1,
        post_width: width,
        post_height: height,
        autothumbmode: 'addthumbs',
        dumprate: 1,
        dumptype: 'numberofframes',
        transcoder: 'ffmpeg',
        findtags: 'sourcefile',
        lframe: time,
        fframe: time
    };

    return dispatch => {
        dispatch({ type: actionTypes.CLIP_GRAB_MAINTHUMB_START });
        window.flow.newProcess('vob2jpg', 'Flow2 addthumbs', { clipid: clipId, parameters: params, tags: CHAPTER_MARK + "," + CHAPTER_MARK + chapter }).then(res => {
            console.log(res);
            /*dispatch(actions.getClipById(clipId));
            dispatch(actions.updateMetadata("clip", clipId, {}));*/
            let interval = setInterval(function () {
                window.flow.getProcess(res.processid).then(p => {
                    console.log(p);
                    console.log(p.getStatus());
                    if (p.getStatus() == 'done') {
                        clearInterval(interval);
                        dispatch(actions.getClipById(clipId));
                        //dispatch({ type: actionTypes.CLIP_GRAB_MAINTHUMB_SUCCESS });
                    } else if (p.getStatus() == 'error') {
                        clearInterval(interval);
                        //dispatch({ type: actionTypes.CLIP_GRAB_MAINTHUMB_FAIL });
                    }
                })
            }, 2000);
        }).catch(res => {
            console.log(res);
            dispatch({ type: actionTypes.CLIP_GRAB_MAINTHUMB_FAIL });
        });
    }
}

export const deleteRefChapter = (id) => {
    return dispatch => {
        window.flow.delComments(id).then(res => {

        }).catch(res => {
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const setTab = (tab) => {
    return dispatch => {
        dispatch({ type: actionTypes.SET_TIME_COMMENT_TAB, tab: tab });
    };
};
